<template>
	<div class="retrograde-page-wrapper">
		<div class="container">
			<div class="row">
				<form @submit.prevent="handleFormSubmit">
					<div
						class="retrograde-input-content"
						v-for="singleRetrograde of retrogrades"
						:key="singleRetrograde.Question"
					>
						<h3>
							<label
								:for="`planet_${singleRetrograde.Question}`"
							>
								{{ singleRetrograde.Label }}
							</label>
						</h3>
						
						<!-- English Answer -->
						<label class="language-label">English</label>
						<textarea
							type="text"
							:id="`planet_${singleRetrograde.Question}`"
							:name="`planet_${singleRetrograde.Question}`"
							v-model="singleRetrograde.Answer"
							placeholder="English interpretation..."
						/>
						
						<!-- German Answer - NEW -->
						<label class="language-label">German (Deutsch)</label>
						<textarea
							type="text"
							:id="`planet_${singleRetrograde.Question}_de`"
							:name="`planet_${singleRetrograde.Question}_de`"
							v-model="singleRetrograde.AnswerDe"
							placeholder="Deutsche Interpretation..."
						/>
					</div>
					<div class="buttons-wrapper">
						<button @click.prevent="handleCancelButton">cancel</button>
						<input type="submit" value="save">
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import SolFileAPIInstance from '@/api'

export default {
	name: "RetrogradeTable",
	data() {
		return {
			retrogrades: []
		}
	},
	mounted() {
		this.fetchInitialData()
	},
	methods: {
		async fetchInitialData() {
      const response = await SolFileAPIInstance.getRetrogrades()
      if (response.data) {
        const { retrogrades } = response.data
        // Ensure AnswerDe exists for each retrograde
        this.retrogrades = retrogrades.map(item => ({
          ...item,
          AnswerDe: item.AnswerDe || ''  // Default to empty string if not present
        }))
      }
		},
		async handleFormSubmit() {
			await SolFileAPIInstance.saveRetrogrades(this.retrogrades)
      await this.fetchInitialData()
		},
		handleCancelButton() {
			this.$router.push({
				path: '/'
			})
		}
	}
}
</script>

<style scoped lang="scss">

.retrograde-page-wrapper {
	padding: 25px;

	form {
		width: 100%;
	}

	.buttons-wrapper {
		display: flex;
		flex-direction: revert;
		justify-content: flex-end;

    > * {
      margin: 10px
    }
	}

	.language-label {
		display: block;
		font-weight: 600;
		margin-bottom: 8px;
		margin-top: 15px;
		color: #fff;
		font-size: 14px;
		
		&:first-of-type {
			margin-top: 0;
		}
	}

	textarea {
		max-width: 100%;
		min-width: 100%;
		min-height: 100px;
		box-sizing: border-box;
		display: block;
		padding: 15px;
		background-color: #fff;
		border: none;
		color: black;
		border-radius: 6px;
		width: 100%;
		margin: 0 auto 15px;

		@media (max-width: 767px) {
			min-height: 200px;
		}

		&:focus {
			outline: none;
		}
	}

	button,
	input[type="submit"] {
		box-sizing: border-box;
		padding: 15px;
		background-color: #fff;
		border: none;
		color: black;
		border-radius: 6px;
		width: 150px;
		cursor: pointer;
		transition: ease all .4s;

		&:focus {
			outline: none;
		}

		&:hover {
			color: white;
			background-color: #34558b;
		}

		&:last-child {
			margin-right: 0;
		}
	}
}

.container {
	max-width: 1200px;
	margin: 0 auto;
	padding: 0 15px;
}

.row {
	margin: 0 -15px;
	display: flex;
	flex-wrap: wrap;
}

</style>